<template>
    <div class="product-images">
        <carousel :autoplay="false" :data="imageEls" :controls="imageEls.length > 1" :indicators="imageEls.length > 1"></carousel>
    </div>
</template>
<script>
    export default {
        props: {
            images: Array
        },
        data(){
            return {
                imageEls: []
            }
        },
        computed: {

        },
        mounted(){
            let els = [];
            for(let image of this.images){
                els.push(`<img src="${image.url}" />`);
            }
            this.imageEls = els;
        }
    }
</script>
<style lang="scss">
    .carousel--slidable{
        touch-action: initial !important;
    }
    .carousel__list{
        li{
            position: relative;
            padding-top: 100%;

            span{
                position: absolute;
                top: 0;
                left: 0;
                height: 100%;
                width: 100%;
                z-index: 1;

                img{
                    height: 100%;
                    width: 100%;
                    object-fit: contain;
                }
            }
        }
    }

    .carousel__control {
        z-index: 2;
    }
</style>